// data-testid registry for the Tech Shiksha site
export const NAV = {
  logo: "nav-logo",
  home: "nav-home-link",
  contact: "nav-contact-link",
  cta: "nav-cta-button",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  explore: "hero-explore-button",
  contact: "hero-contact-button",
};

export const TOPICS = {
  section: "topics-section",
  card: (slug) => `topic-card-${slug}`,
};

export const WFH = {
  section: "wfh-section",
  applyBtn: "wfh-apply-button",
  dialog: "wfh-application-dialog",
  next: "wfh-form-next",
  back: "wfh-form-back",
  submit: "wfh-form-submit",
  field: (name) => `wfh-field-${name}`,
  success: "wfh-form-success",
  resume: "wfh-field-resume",
};

export const CONTACT = {
  page: "contact-page",
  form: "contact-form",
  field: (name) => `contact-field-${name}`,
  submit: "contact-form-submit",
  success: "contact-form-success",
  resume: "contact-field-resume",
  whatsapp: "contact-whatsapp-button",
};

export const FOOTER = {
  section: "footer-section",
  social: (name) => `footer-social-${name}`,
};

export const JOBS = {
  page: "jobs-page",
  search: "jobs-search-input",
  sort: "jobs-sort-toggle",
  filter: (key) => `jobs-filter-${key}`,
  remoteSection: "jobs-remote-section",
  onsiteSection: "jobs-onsite-section",
  remoteCount: "jobs-remote-count",
  onsiteCount: "jobs-onsite-count",
  row: (section, i) => `jobs-${section}-row-${i}`,
  companyLink: (section, i) => `jobs-${section}-company-${i}`,
  applyLink: (section, i) => `jobs-${section}-apply-${i}`,
  prevPage: (section) => `jobs-${section}-prev`,
  nextPage: (section) => `jobs-${section}-next`,
  empty: (section) => `jobs-${section}-empty`,
};
